// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\t.st0{opacity:0.2;fill:#210D22;}\r\n\t.st1{fill:#7B7C81;}\r\n\t.st2{fill:#838386;}\r\n\t.st3{opacity:0.2;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#89888A;}\r\n\t.st6{fill:#2C40A5;}\r\n\t.st7{fill:#210D22;}\r\n\t.st8{fill:#73A2CA;}\r\n\t.st9{fill:#310F32;}\r\n\t.st10{opacity:0.6;}\r\n\t.st11{fill:#FDFFFF;}\r\n", ""]);
// Exports
module.exports = exports;
